import React from 'react';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { useOrderContext } from '../../../../../providers/OrderProvider';

const CustomerDetail = () => {
	const { order } = useOrderContext();
	const customerInfo = order?.customerInfo;

	return (
		<>
			{customerInfo?.staffName && (
				<EventModalMediaContent icon='user' heading='客户信息'>
					<div className='d-flex flex-column gap-1'>
						<p className='mb-0 fs-10 fw-normal'>
							联系人：<a href='#!'>{customerInfo.staffName}</a>
						</p>
						{customerInfo?.phone && (
							<p className='mb-0 fs-10 fw-normal'>
								电话：<a href='#!'>{customerInfo.phone}</a>
							</p>
						)}
					</div>
				</EventModalMediaContent>
			)}
		</>
	);
};

export default CustomerDetail;
